/**
 * @file index.tsx
 *
 * @fileoverview Renders link referring to the font styles file.
 */
import localFont from 'next/font/local';
import { Prata } from 'next/font/google';
const roboto = localFont({
  src: [
    {
      path: './../../../../../public/fonts/woff2/Roboto-regular.woff2',
      weight: '400',
      style: 'normal',
    },
    {
      path: './../../../../../public/fonts/woff2/Roboto-semibold.woff2',
      weight: '700',
      style: 'normal',
    },
    {
      path: './../../../../../public/fonts/woff2/Roboto-bold.woff2',
      weight: '900',
      style: 'regular',
    },
  ],
});
const prata = Prata({
  weight: ['400'],
  style: ['normal'],
  subsets: ['latin'],
  display: 'swap',
});

export const NextFontSlot = ({ children }) => (
  <div>
    {children}
    <style jsx global>{`
      :root {
        --font-family-body: ${roboto.style.fontFamily};
        --font-family-headings: ${prata.style.fontFamily};
      }
    `}</style>
  </div>
);
